import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import ReactTable from 'react-table';
import {
  Col,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import Filters from '../../components/Filters/Filters';
import PaginationTable from '../../components/Pagination/PaginationTable';
import getSortHeaderProps from '../../utils/get-sorted-headers';
import { showConfirmModal } from '../../modules/modals/confirmService';
import { withTranslation } from 'react-i18next';

class AdjustedMixTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorted: [{id: 'extraProductItemCode', desc: false}],
      filter: '',
    };
  }

  onEdit = id => {
    const { mixStore, onEdit } = this.props;
    mixStore.selectAdjustedProduct(Number(id));
    onEdit();
  };

  onDelete = (id, code) => {
    const { mixStore, onDelete, t } = this.props;

    return showConfirmModal({
      title: `${t('Are you sure you want to delete adjusted mix designs')} ${code}?`,
      okLabel: t('Yes'),
      cancelLabel: t('No'),
      enableEscape: false,
    })
      .then(() => {
        onDelete();
        mixStore.deleteAdjustedMix(Number(id));
      })
      .catch(() => {});
  };

  getColumns = () => {
    const { sorted } = this.state;
    const { t } = this.props;

    return [
      {
        headerText: t('Code'),
        accessor: 'extraProductItemCode',
        id: 'extraProductItemCode',
        className: 'sticky',
        headerClassName: 'sticky',
        ...getSortHeaderProps(sorted),
        maxWidth: 120,
      },
      {
        headerText: t('Description'),
        accessor: 'extraProductItemDescription',
        id: 'extraProductItemDescription',
        ...getSortHeaderProps(sorted),
      },
      {
        accessor: 'actions',
        maxWidth: 120,
        Cell: row => (
          <div className="text-right">
            <a className="btn btn-sm btn-default btn-action"
              title="Edit"
              onClick={() => this.onEdit(row.original.id)}>
              <i className="fa fa-pencil"/>
            </a>
            <a className="btn btn-sm btn-default btn-action"
              title="Remove"
              onClick={() => this.onDelete(row.original.id, row.original.extraProductItemCode)}>
              <i className="fa fa-remove"/>
            </a>
          </div>
        ),
      },
    ];
  };

  handleChange = (e) => {
    const filter = e.target.value;
    this.setState({ filter });
  };

  render() {
    const { mixStore, t } = this.props;
    const { adjustedMixDesigns } = mixStore;
    const { filter } = this.state;

    return (
      <div className={`adjusted-mixes-${adjustedMixDesigns.length}`}>
        <Col sm={4} xs={10} className={'no-padding'}>
          <FormGroup>
            <FormControl
              type="text"
              value={filter}
              placeholder={t('Search')}
              onChange={this.handleChange}
            />
          </FormGroup>
        </Col>
        <Filters filter={filter} data={adjustedMixDesigns} renderData={(items) => (
          <ReactTable
            className="-highlight mix-table"
            data={items}
            columns={this.getColumns()}
            sorted={this.state.sorted}
            onSortedChange={sorted => this.setState({ sorted })}
            showPaginationTop={false}
            showPaginationBottom={true}
            showPageSizeOptions={true}
            PaginationComponent={PaginationTable}
            resizable={false}
            minRows={1}
            defaultPageSize={100}
            getTrProps={(state, rowInfo) => {
              if (rowInfo && rowInfo.row) {
                return {
                  onClick: () => {
                    this.onEdit(rowInfo.original.id);
                    this.setState({
                      selected: rowInfo.index,
                    });
                  },
                  className: rowInfo.index === this.state.selected ? 'row-selected': '',
                };
              }
              return {};
            }}
          />
        )} />
      </div>
    );
  }
}

export default withTranslation()(inject('mixStore')(observer(AdjustedMixTable)));
